import { SearchCategory } from './types';

/** Lanes render in this order regardless of the order their frames arrive, so the
 *  list does not reshuffle while the stream is still filling in. */
export const SEARCH_CATEGORY_ORDER: SearchCategory[] = [
  'ORDER',
  'MEDIA_PLAN',
  'SPACE',
  'PACKAGE',
  'LOCATION',
  'CLIENT',
  'COMPANY',
  'USER',
];

const CATEGORY_LABEL_KEY: Record<SearchCategory, string> = {
  ORDER: 'search.categories.order',
  MEDIA_PLAN: 'search.categories.media_plan',
  SPACE: 'search.categories.space',
  PACKAGE: 'search.categories.package',
  LOCATION: 'search.categories.location',
  CLIENT: 'search.categories.client',
  COMPANY: 'search.categories.company',
  USER: 'search.categories.user',
};

export const getSearchCategoryLabelKey = (category: SearchCategory): string =>
  CATEGORY_LABEL_KEY[category];

export const getLaneStatusLabelKey = (status: string): string =>
  `search.lane_status.${status.toLowerCase()}`;
